import React from 'react';

import { StyledBadge } from '@/shared/components/ui/tabs/components/items-count-badge/items-count-badge.styled';
import { ItemsCountBadgeProps } from '@/shared/components/ui/tabs/components/items-count-badge/items-count-badge.types';
import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';

export const ItemsCountBadge: React.FC<ItemsCountBadgeProps> = ({
  itemsCount,
  truncateAt,
}) => {
  const isTruncated = truncateAt && (itemsCount ?? 0) > truncateAt;
  const label = isTruncated ? `${truncateAt}+` : itemsCount;
  const tooltipTitle = isTruncated ? itemsCount : undefined;

  if (!itemsCount) {
    return null;
  }

  return (
    <Tooltip title={tooltipTitle}>
      <StyledBadge label={label} />
    </Tooltip>
  );
};
